















import Vue from 'vue';

export default Vue.extend({
  name: 'BgmController',
  data() {
    return {
      audio: new Audio,
      playing: false
    }
  },
  watch: {
    playing(value) {
      if (value) this.audio.play();
      else this.audio.pause();
    }
  },
  methods: {
    playAudio () {
      this.playing = true;
    },
    pauseAudio () {
      this.playing = false;
    },
  },
  mounted() {
    this.audio = this.$el.querySelectorAll('audio')[0] as InstanceType<typeof Audio>;
    this.audio.addEventListener('pause', () => { this.playing = false; });
		this.audio.addEventListener('play', () => { this.playing = true; });
  }
});
